import { FormatTypes } from '@constants/templateDictionaries';

export const DOCUMENT_NAMES_MAP = {
  [FormatTypes.RESUME]: 'Resume',
  [FormatTypes.COVER_LETTER]: 'Cover Letter',
  [FormatTypes.AI_MOCK_INTERVIEW]: 'AI Mock Interview',
  [FormatTypes.CAREER_FINANCIALS]: 'Career Financials',
};
